import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-table-selection-fields-wrapper',
  templateUrl: './table-selection-fields-wrapper.component.html',
  styleUrls: ['./table-selection-fields-wrapper.component.scss']
})
export class TableSelectionFieldsWrapperComponent extends FieldWrapper {
  orphanTablesName = `Zzzzzz`;
  orphanTablesVisibleName = `Others`;
}
